/**
 * Canonical event name constants for PostHog analytics.
 *
 * All call sites MUST import from this file — never use string literals.
 * Deferred events (no call sites yet) are stubbed as exported constants
 * so they appear in one place for discoverability.
 */

// ── Auth events ──────────────────────────────────────────────────────────────
export const EVENT_SIGNUP = 'signup' as const;
export const EVENT_LOGIN = 'login' as const;
export const EVENT_LOGOUT = 'logout' as const;

// ── Domain events ─────────────────────────────────────────────────────────────
export const EVENT_PROPERTY_CREATED = 'property_created' as const;
export const EVENT_LOCATION_CREATED = 'location_created' as const;
export const EVENT_SEASON_CREATED = 'season_created' as const;
export const EVENT_TASK_COMPLETED = 'task_completed' as const;
export const EVENT_TASK_SNOOZED = 'task_snoozed' as const;
export const EVENT_LOG_ENTRY_CREATED = 'log_entry_created' as const;
export const EVENT_HUNT_STARTED = 'hunt_started' as const;
export const EVENT_HARVEST_RECORDED = 'harvest_recorded' as const;
export const EVENT_MAP_LAYER_TOGGLED = 'map_layer_toggled' as const;
export const EVENT_FORECAST_PAGE_VIEWED = 'forecast_page_viewed' as const;

// ── Deferred (M56 — tier gating) ─────────────────────────────────────────────
export const UPGRADE_PROMPT_SHOWN = 'upgrade_prompt_shown' as const;
export const UPGRADE_INITIATED = 'upgrade_initiated' as const;
